<template>
  <div @click="handleShowDetailNew" class="item-info-news">
    <div>
      <img class="image-news" :src="objectData.image || imageDefault" />
    </div>
    <div style="padding:0 15px">
      <div class="content-container">
        <h3 class="content-news">
          {{ objectData.name }}
        </h3>
      </div>
      <!-- <p class="degree content-des mt-10">
        {{
          objectData.description ||
            "The to his thought our appearance, lamps, money he The to his thought our appearance, lamps, money he d discipline sitting and profitable entered thoughts her times."
        }}
      </p> -->
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/formatData";

export default {
  name: "banner",
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      imageDefault:
        "https://images.inc.com/uploaded_files/image/1920x1080/getty_492755552_201646.jpg"
    };
  },
  methods: {
    handleShowDetailNew() {
      this.$router.push(`/Courses/${this.objectData.course_topic_id}`);
    },
    formatDate
  }
};
</script>
<style scoped>
.item-info-news {
  background: #ffff;
  border-radius: 12px;
  max-width: 395px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border-width: 0px, 1px, 1px, 1px;

  border-style: solid;

  border-color: #e3e3e3;
}

.content-news {
  text-align: left;
  color: black;
  font-size: 18px;
  font-weight: 700;
  margin-top: 10px;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word; /* Cho phép văn bản xuống dòng 1 lần */
  max-width: 370px;
}
.content-des {
  text-align: left;
  color: #828287;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-wrap: break-word; /* Cho phép văn bản xuống dòng 1 lần */
  max-width: 370px;
  overflow: hidden;
  height: 80px;
}
.image-news {
  height: 100%;
  max-height: 180px;
  width: 100%;
  min-width: 350px;
  max-width: 395px;
  object-fit: cover;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .item-info-news {
    background: #ffff;
    border-radius: 12px;
    max-width: 350px;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    border-width: 0px, 1px, 1px, 1px;

    border-style: solid;

    border-color: #e3e3e3;
  }
  .content-news {
    text-align: left;
    color: black;
    font-size: 17px;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-bottom: 5px;
    font-weight: 700;
    margin-bottom: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-wrap: break-word; /* Cho phép văn bản xuống dòng 1 lần */
    max-width: 370px;
  }
  .content-des {
    text-align: left;
    color: #828287;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-wrap: break-word; /* Cho phép văn bản xuống dòng 1 lần */
    max-width: 370px;
    overflow: hidden;
    height: 80px;
  }
  .image-news {
    height: 100%;
    max-height: 180px;
    width: 100%;
    max-width: 350px;
    object-fit: cover;
  }
}
</style>
